import RichTextInput from 'ra-input-rich-text'
import React from 'react'
import { DateTimeInput , required, Edit, FormTab, TabbedForm, TextInput, NumberInput, minValue } from 'react-admin'
import { EditToolbar, EditActions } from '../utilities/EditView'
import Title from "../Title";


const TradeRevAutoProxyEdit = props => (
  <Edit title={<Title type="TradeRev Auto Proxy" />} actions={<EditActions NoShowButton />} {...props}>
    <TabbedForm toolbar={<EditToolbar />}>
      <FormTab label='TradeRev Auto Proxy Details'>

        <TextInput label="Trim" source="trim" />
        <NumberInput label="Rate" source="rate" step={0.01} validate={[required(), minValue(0)]} initialValue={1.23} />
        <NumberInput label="US Selling Price" source="us" step={1} validate={[required(), minValue(0)]} />
        <NumberInput label="Proxy" source="proxy" step={1} validate={[required()], minValue(0)} />
        <TextInput label="Proxy Suggestion" source="proxy_suggestion"  />
        <DateTimeInput  label="End" source="end" />

      </FormTab>
    </TabbedForm>
  </Edit>
)

export default TradeRevAutoProxyEdit
